"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractCSSFromComponent = void 0;
var _serialize = require("@emotion/serialize");
// This util needs to extract css from emotion components
// to reuse it for nested elements
// templateStringFn is string that use `props => string` function

/* 
  eg. Adding h1
  const Container = styledWithTheme('div')(props => ({
    h1: extractCSSFromComponent(H1, props),
  }))
*/

const extractCSSFromComponent = (Component, props, additionalCSS) => {
  const styles = [];
  for (const templateStringFn of Component.__emotion_styles) {
    if (typeof templateStringFn === 'function') {
      styles.push(templateStringFn({
        ...props,
        ...Component.defaultProps
      }));
    } else {
      styles.push(templateStringFn);
    }
  }
  return (0, _serialize.serializeStyles)(styles, {}).styles.concat(additionalCSS || '');
};
exports.extractCSSFromComponent = extractCSSFromComponent;